import api from 'utils/api';
import SessionActions from './SessionActions';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import ReferralsActions from './ReferralsActions';
import { receiveReferralWizardData } from './ReferralWizardActions';

import uid from 'uid';
import Raven from 'raven-js';

export const RECEIVE_CURRENT_AGENT = 'RECEIVE_CURRENT_AGENT';

const receiveCurrentAgent = (currentAgent) => ({
  type: RECEIVE_CURRENT_AGENT,
  currentAgent: currentAgent,
});

const fetchCurrentAgent = (dispatch) => {
  // use uid to avoid caching :(
  return api
    .get(`/agent_portal/api/current_agent?uid=${uid()}`)
    .then((response) => {
      const data = response.data;

      dispatch(receiveCurrentAgent(data.currentAgent));

      SessionActions.updateSubdomainOrganization({
        subdomainOrganization: data.subdomainOrganization,
        subdomainLogoUrl: data.subdomainLogoUrl,
      });
      SessionActions.connectChannels({
        sessionChannelId: data.sessionChannelId,
        pusherConfig: data.pusherConfig,
        referralChannelIds: data.referralChannelIds,
      });
      // Pluck the flash messages (if any) out of the response and display to user
      FlashMessageActions.dispatchServerFlashMessages({
        flashMessages: data.flashMessages,
      });

      dispatch(
        receiveReferralWizardData(
          data.referralWizard.availableNetworks,
          data.referralWizard.inboundReferrableSpecialties
        )
      );

      ReferralsActions.updatePendingReferralsCount({
        pendingReferralsCount: data.pendingReferralsCount,
      });

      if (
        process.env.REACT_APP_HELP_SCOUT_ENABLED === 'true' &&
        process.env.REACT_APP_HELP_SCOUT_BEACON_ID &&
        !data.currentAgent.masquerading
      ) {
        window.Beacon('identify', {
          signature: data.currentAgent.helpScout.userHash,
          user_id: data.currentAgent.helpScout.userId,
          user_type: data.currentAgent.helpScout.userType,
          name: data.currentAgent.helpScout.name,
          email: data.currentAgent.helpScout.email,
          organization_name: data.currentAgent.helpScout.organizationName,
          organization_id: data.currentAgent.helpScout.organizationId,
        });
      }

      if (process.env.REACT_APP_USE_RAVEN === 'true') {
        Raven.setUserContext(data.currentAgent.raven.userContext);
      }

      return response;
    });
};

export { fetchCurrentAgent, receiveCurrentAgent };
